import gsap from 'gsap'
import { sizes } from "@/js/sizes";

export default {
	name: "AppHeader",
	data() {
		return {
			isOpen: false,
			isOpenForHover: true,
			isFixedLogo: false,
			tl: null,
			isLogoAnimted: false,
			tlEnterLogo: null,
			tlLeaveLogo: null
		}
	},
	mounted() {
		this.tl = gsap.timeline()
		this.checkCurrentLanguage();

		window.addEventListener('scroll', this.fixedHeaderLogo)
		window.addEventListener('resize', this.handleResize)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.fixedHeaderLogo)
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		checkCurrentLanguage() {
			const languageList = document.querySelectorAll('.wpml-ls-item');
			languageList.forEach(el => {
				if (el.classList.contains('wpml-ls-current-language') && el.classList.contains('wpml-ls-item-pl')) {
					this.$refs.languageStick.classList.add('var_pl');
				} else {
					this.$refs.languageStick.classList.remove('var_pl');
				}
			})
		},
		fixedHeaderLogo() {
			const logoOffsetTop = this.$refs.headerLogo.offsetTop;
			const burgerOffsetTop = parseFloat(window.getComputedStyle(this.$refs.headerBurger).top) + 10;
			const fixedValue = logoOffsetTop - burgerOffsetTop;

			if (window.scrollY > fixedValue) {
				this.isFixedLogo = true;

				if (!this.isLogoAnimted) {
					this.isLogoAnimted = true;
					this.animationEnterLogo();
				}
			} else if (window.scrollY < fixedValue) {
				this.isFixedLogo = false;

				if (this.isLogoAnimted) {
					this.isLogoAnimted = false;
					this.animationLeaveLogo();
				}
			}
		},
		animationEnterLogo() {
			const svg = document.querySelector('#group2');

			let mqlB = window.matchMedia('(max-width: 800px)');
			this.tlEnterLogo = gsap.timeline();

			if (this.tlLeaveLogo && this.tlLeaveLogo.isActive()) {
				this.tlLeaveLogo.kill();
			}

			if (mqlB.matches) {
				this.tlEnterLogo
					.to(svg.children[2], { transformOrigin: 'center top', scale: 0.5, duration: 0.3 })
					.to(svg.children[0], { y: -30, opacity: 0, duration: 0.3 }, '-=0.3')
					.to(svg.children[1], { y: -30, opacity: 0, duration: 0.3 }, '-=0.2')
			} else {

				this.tlEnterLogo
					.to(svg.children[2], { transformOrigin: '0px 0px', x: 0, scale: 0.5, duration: 0.3 })
					.to(svg.children[0], { x: -20, opacity: 0, duration: 0.3 }, '-=0.3')
					.to(svg.children[1], { x: -20, opacity: 0, duration: 0.3 }, '-=0.2')
			}
		},
		animationLeaveLogo() {
			const svg = document.querySelector('#group2');
			this.tlLeaveLogo = gsap.timeline();

			if (this.tlEnterLogo && this.tlEnterLogo.isActive()) {
				this.tlEnterLogo.kill();
			}

			this.tlLeaveLogo
				.to(svg.children[1], { x: 0, y: 0, opacity: 1, duration: 0.3 })
				.to(svg.children[0], { x: 0, y: 0, opacity: 1, duration: 0.3 }, '-=0.15')
				.to(svg.children[2], { x: 63, scale: 1, duration: 0.3 }, '-=0.3')
		},
		toggleMenu() {
			this.isOpen = !this.isOpen

			const transDelay = window.innerWidth < sizes.b ? 0.28 : 0.2
			const transform = this.isOpen ? 'translateX(0)' : window.innerWidth < sizes.b ? 'translateY(-100vh)' : 'translateX(500px)'

			if (this.isOpen) {
				gsap.to(this.$refs.menu, { transform: transform, visibility: 'visible' })
				gsap.to(this.$refs.overlay, { duration: 0.6, visibility: 'visible', opacity: 0.9 })
			} else {
				gsap.to(this.$refs.menu, { delay: transDelay, transform: transform, onComplete: () => gsap.set(this.$refs.menu, { visibility: 'hidden' }) })
				gsap.timeline().to(this.$refs.overlay, { duration: 1, autoAlpha: 0 })

			}

			if (this.isOpen) return this.xBurger()
			this.lineBurger()
		},
		xBurger() {
			this.isOpenForHover = false
			this.timelineCondition()
			this.toggleItems(1)

			this.tl
				.to(this.$refs.burgerTop, 0.3, { rotate: 45, x: -3, y: 25, scaleX: 1, backgroundColor: '#08473e' })
				.set(this.$refs.burgerMid, { autoAlpha: 0 }, '-=0.2')
				.to(this.$refs.burgerBottom, 0.3, { rotate: -45, y: 2.4, x: -3, scaleX: 1, backgroundColor: '#08473e' }, '-=0.3')
				.to(this.$refs.menuWord, 0.4, { autoAlpha: 0 }, '-=0.6')

			this.blockScrollPage()

		},
		blockScrollPage() {
			if (window.innerWidth < sizes.b && this.isOpen) {
				document.documentElement.style.overflowY = 'hidden'
			} else {
				document.documentElement.style.overflowY = 'visible'
			}
		},
		lineBurger() {
			this.isOpenForHover = false
			this.timelineCondition()
			this.toggleItems(0)

			this.tl
				.to(this.$refs.burgerTop, 0.3, { rotate: 0, x: 0, y: 10, scaleX: 1, backgroundColor: '#fcff00' }, '+=0.3')
				.to(this.$refs.burgerMid, { duration: 0.1, autoAlpha: 1 }, '-=0.2')
				.to(this.$refs.burgerBottom, 0.3, { rotate: 0, y: 22, x: 0, scaleX: 0.6, backgroundColor: '#fcff00', onComplete: () => this.isOpenForHover = true }, '-=0.6')
				.to(this.$refs.menuWord, 0.4, { autoAlpha: 1 }, '-=0.6')

			this.blockScrollPage()

		},
		toggleItems(shouldEnter) {
			const items = document.querySelectorAll('.header__menu__list__item')

			if (shouldEnter) return gsap.timeline({ delay: 0.08 }).to(items, { x: 0, autoAlpha: 1, duration: 0.6, stagger: 0.03, ease: 'Power2.easeInOut' })
			gsap.timeline().to(items, { x: 50, autoAlpha: 0, duration: 0.4, stagger: 0.03, ease: 'Power2.easeInOut' })
		},
		scrollToModule(ev) {
			const el = document.querySelector('.' + ev.currentTarget.dataset.scroll)
			const offset = window.innerWidth < sizes.b ? 70 :
				window.innerWidth < sizes.c ? 120 :
					window.innerWidth < sizes.d ? 150 : 180

			window.scrollTo({
				top: el.offsetTop - offset,
				behavior: "smooth"
			});

			this.toggleMenu()

		},
		mouseEnter() {
			this.timelineCondition()

			if (this.isOpenForHover && !this.isOpen) {
				this.tl
					.to(this.$refs.burgerTop, 0.3, { scaleX: 0.6 })
					.to(this.$refs.burgerBottom, 0.3, { scaleX: 1 }, '-=0.3')
			} else if (!this.isOpenForHover) {
				this.tl
					.set(this.$refs.burgerTop, { transformOrigin: 'left', x: 5, y: 6 })
					.to(this.$refs.burgerTop, 0.3, { scaleX: 0 })
					.set(this.$refs.burgerTop, { transformOrigin: 'right', x: -3, y: 24 })
					.to(this.$refs.burgerTop, 0.3, { scaleX: 1, transformOrigin: 'right', onComplete: () => this.isOpenForHover = false })
			}
		},
		mouseLeave() {
			this.timelineCondition()

			if (this.isOpenForHover && !this.isOpen) {
				gsap.timeline()
					.to(this.$refs.burgerTop, 0.3, { scaleX: 1 })
					.to(this.$refs.burgerBottom, 0.3, { scaleX: 0.6 }, '-=0.3')
			}
		},
		timelineCondition() {
			if (this.tl && this.tl.isActive()) {
				this.tl.progress(1)
			}
		},
		handleResize() {
			const svg = document.querySelector('#group2');
			this.blockScrollPage();
			this.fixedHeaderLogo();

			let mqlB = window.matchMedia('(max-width: 800px)');
			if (this.isLogoAnimted) {
				gsap.set(svg.children, { clearProps: 'x,opacity,scale,transformOrigin' })

				if (mqlB.matches) {
					gsap.timeline()
						.set(svg.children[2], { transformOrigin: "center top", x: 63, scale: 0.5 })
						.set(svg.children[0], { y: -30, opacity: 0 })
						.set(svg.children[1], { y: -30, opacity: 0 })
				} else {
					gsap.timeline()
						.set(svg.children[2], { x: 0, scale: 0.5 })
						.set(svg.children[0], { x: -20, opacity: 0 })
						.set(svg.children[1], { x: -20, opacity: 0 })
				}
			} else {
				gsap.set(svg.children, { clearProps: 'x,opacity,scale' })
				gsap.set(svg.children[2], { x: 63 })
			}
		}
	}
};
